import Wrapper from './_views/Wrapper.vue';

const parentRouteConfig = {
  name: 'Users',
  to: {
    name: 'users',
    query: {
      pageNum: '1',
      activeOnly: true,
    },
  },
};

export default [
  {
    path: '/users',
    component: Wrapper,
    children: [
      {
        path: '',
        name: 'users',
        component: () => import(/* webpackChunkName: "users" */ './_views/UmsUsers.vue'),
        meta: {
          title: 'Users',
          navigation: {
            position: 1,
            name: 'Users',
            icon: 'people',
            to: {
              name: 'users',
              query: {
                pageNum: '1',
                activeOnly: true,
              },
            },
          },
        },
      },
      {
        path: ':id',
        name: 'user',
        component: () => import(/* webpackChunkName: "user" */ './_views/UmsUser.vue'),
        meta: {
          title: 'User profile',
          parent: parentRouteConfig,
        },
      },
    ],
  },
  {
    path: '/',
    redirect: {
      name: 'users',
      query: {
        pageNum: '1',
        activeOnly: true,
      },
    },
  },
];
